
import ControllerNewsletter from 'Controllers/ControllerNewsletter'

export default {
  components: {
    ControllerNewsletter,
  },
  data() {
    return {
      inView: false,
    }
  },
  methods: {
    callback() {
      this.$toast.success('Vaš e-mail je uspješno poslan. Hvala vam!')
    },
  },
}
